// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.hpht-rheology-toolbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.hpht-rheology-import-link {
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.hpht-rheology-add-reading {
  margin-left: auto;
}

.hpht-rheology-file-input {
  display: none;
}

.hpht-rheology-import-message {
  color: #1a7f37;
  font-size: 0.82rem;
  margin-bottom: 0.4rem;
}

.hpht-rheology-import-error {
  color: #b42318;
  font-size: 0.82rem;
  margin-bottom: 0.4rem;
}

.hpht-rheology-matrix {
  overflow-x: auto;
}

.rheology-matrix {
  display: grid;
  gap: 0.45rem 0.55rem;
  align-items: left;
}

.rheology-header {
  width: 100%;
  max-width: 220px;
  justify-self: center;
  font-size: 0.83rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #d9e2ec;
}

.row-label-column {
  width: 100%;
  max-width: 140px;
  justify-self: end;
  text-transform: none;
  text-align: right;
}

.rheology-row-label {
  width: 100%;
  max-width: 140px;
  justify-self: end;
  font-size: 0.82rem;
  color: #475569;
  font-weight: 600;
  text-align: right;
}

.rheology-cell {
  width: 100%;
  max-width: 220px;
  min-width: 0;
  display: flex;
  justify-content: center;
  justify-self: center;
}

.rheology-cell > input {
  width: 100%;
  text-align: center;
}

.rheology-cell[readonly] > input,
.rheology-cell > input[readonly] {
  background-color: #f1f3f5;
  color: #334155;
}

.rheology-temp-cell {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.rheology-temp-cell > input {
  min-width: 0;
  width: auto;
  flex: 1 1 auto;
}

.rheology-high-reading {
  background-color: #f8d7da;
  border-color: #dc3545;
}

.rheology-temp-remove {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  line-height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-hpht-rheology-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAa3H;;AAZA;EAAsB,aAAA;EAAe,2DAAA;EAA6D,iBAAA;AAkBlG;;AAjBA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AAuB5D;;AAtBA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AA6BjE;;AA3BA;EAAyB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,qBAAA;AAkC1E;;AAjCA;EAA6B,gBAAA;EAAkB,0BAAA;EAA4B,0BAAA;AAuC3E;;AAtCA;EAA6B,iBAAA;AA0C7B;;AAzCA;EAA4B,aAAA;AA6C5B;;AA5CA;EAAgC,cAAA;EAAgB,kBAAA;EAAoB,qBAAA;AAkDpE;;AAjDA;EAA8B,cAAA;EAAgB,kBAAA;EAAoB,qBAAA;AAuDlE;;AArDA;EAAwB,gBAAA;AAyDxB;;AAvDA;EACE,aAAA;EACA,oBAAA;EACA,iBAAA;AA0DF;;AAvDA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gCAAA;AA0DF;;AAvDA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AA0DF;;AAvDA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA0DF;;AAvDA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AA0DF;;AAvDA;EACE,WAAA;EACA,kBAAA;AA0DF;;AAvDA;;EAEE,yBAAA;EACA,cAAA;AA0DF;;AAvDA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA0DF;;AAvDA;EACE,YAAA;EACA,WAAA;EACA,cAAA;AA0DF;;AAvDA;EACE,yBAAA;EACA,qBAAA;AA0DF;;AAvDA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA0DF","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-field { display: flex; flex-direction: column; gap: 0.3rem; }\n.test-detail-label { margin: 0; font-size: 0.85rem; color: #555; font-weight: 600; }\n\n.hpht-rheology-toolbar { display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem; }\n.hpht-rheology-import-link { font-weight: 600; text-decoration: underline; text-underline-offset: 2px; }\n.hpht-rheology-add-reading { margin-left: auto; }\n.hpht-rheology-file-input { display: none; }\n.hpht-rheology-import-message { color: #1a7f37; font-size: 0.82rem; margin-bottom: 0.4rem; }\n.hpht-rheology-import-error { color: #b42318; font-size: 0.82rem; margin-bottom: 0.4rem; }\n\n.hpht-rheology-matrix { overflow-x: auto; }\n\n.rheology-matrix {\n  display: grid;\n  gap: 0.45rem 0.55rem;\n  align-items: left;\n}\n\n.rheology-header {\n  width: 100%;\n  max-width: 220px;\n  justify-self: center;\n  font-size: 0.83rem;\n  font-weight: 700;\n  color: #334155;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  padding-bottom: 0.2rem;\n  border-bottom: 1px solid #d9e2ec;\n}\n\n.row-label-column {\n  width: 100%;\n  max-width: 140px;\n  justify-self: end;\n  text-transform: none;\n  text-align: right;\n}\n\n.rheology-row-label {\n  width: 100%;\n  max-width: 140px;\n  justify-self: end;\n  font-size: 0.82rem;\n  color: #475569;\n  font-weight: 600;\n  text-align: right;\n}\n\n.rheology-cell {\n  width: 100%;\n  max-width: 220px;\n  min-width: 0;\n  display: flex;\n  justify-content: center;\n  justify-self: center;\n}\n\n.rheology-cell > input {\n  width: 100%;\n  text-align: center;\n}\n\n.rheology-cell[readonly] > input,\n.rheology-cell > input[readonly] {\n  background-color: #f1f3f5;\n  color: #334155;\n}\n\n.rheology-temp-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.rheology-temp-cell > input {\n  min-width: 0;\n  width: auto;\n  flex: 1 1 auto;\n}\n\n.rheology-high-reading {\n  background-color: #f8d7da;\n  border-color: #dc3545;\n}\n\n.rheology-temp-remove {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
